import { TERMINAL_DEMO_VERSION } from '@/lib/terminal-demo-version';

export function TerminalDemoPlayer() {
  return (
    <div
      className="rounded-2xl overflow-hidden border"
      style={{
        borderColor: '#1F2937',
        boxShadow: '0 30px 80px rgba(34, 211, 238, 0.08), 0 10px 30px rgba(0, 0, 0, 0.5)',
      }}
    >
      <div
        style={{
          backgroundColor: '#111827',
          padding: '8px 12px',
          display: 'flex',
          alignItems: 'center',
          gap: 6,
          borderBottom: '1px solid #1F2937',
        }}
      >
        <span style={{ width: 11, height: 11, borderRadius: '50%', backgroundColor: '#ef4444', opacity: 0.8 }} />
        <span style={{ width: 11, height: 11, borderRadius: '50%', backgroundColor: '#f59e0b', opacity: 0.8 }} />
        <span style={{ width: 11, height: 11, borderRadius: '50%', backgroundColor: '#22c55e', opacity: 0.8 }} />
        <span style={{ marginLeft: 12, fontSize: 11, color: '#6B7280', fontFamily: 'ui-monospace, monospace' }}>
          equitylabs · terminal
        </span>
      </div>
      <video
        src={`/terminal-demo.mp4?v=${TERMINAL_DEMO_VERSION}`}
        autoPlay
        loop
        muted
        playsInline
        preload="auto"
        aria-label="Animated demo of EquityLabs Terminal: search bar, watchlist, KPI row, price chart, market movers, and Research mode with Overview, Financials, and Risk tabs"
        style={{ width: '100%', display: 'block', backgroundColor: '#0D1117' }}
      />
    </div>
  );
}
